
export const employeeFullName=(employee)=>{
    return `${employee.name} ${employee.patLastName||''} ${employee.matLastName||''}`
};
